var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigWhiteBmLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 120,
    viewBox: "0 0 73 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9822 75.8969L52.7897 49.9492L65.4961 22.9517C66.6372 20.4874 67.1378 17.7766 66.9517 15.0688C66.7656 12.3611 65.8989 9.7436 64.4313 7.4574C62.9637 5.17121 60.9425 3.28984 58.5538 1.98662C56.1651 0.683391 53.4858 0.000207604 50.7626 0H16.2283C11.9244 0.000272654 7.79682 1.7044 4.75348 4.73757C1.71014 7.77073 0.000273569 11.8845 0 16.174V120L25.419 99.8974H56.7707C59.5933 99.8954 62.3667 99.1603 64.8174 97.7645C67.268 96.3687 69.3114 94.3604 70.746 91.9377C72.1806 89.5149 72.9568 86.7614 72.9982 83.9485C73.0397 81.1357 72.3448 78.3606 70.9822 75.8969ZM53.3334 81.5518H18.3988V18.3393H47.3634L32.5226 49.9492L53.3334 81.5518Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigWhiteBmLogo);
export default __webpack_public_path__ + "static/media/bigWhiteBMLogo.62e7c8258be3c0a6a4ae2e213a1d6b9f.svg";
export { ForwardRef as ReactComponent };